export enum ErrorCode {
    InvalidUser = 'invalid_user'
}
